export default angular.module('animatronApp.services', []);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/module.ts